import {Button, Drawer, message, Select, Space, Spin, Switch, Transfer} from "antd";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import DB_TradePoint from "../../../database/dictionary/trade-point";
import DB_Branch from "../../../database/dictionary/branch";
import {WarningTwoTone} from "@ant-design/icons";

export const DrawerResponseOrgStructure = ({token, org_structure_id, setShow, show}) => {
    const {t} = useTranslation()
    const {tradePointResponsePerson, saveTradePointResponsePerson} = DB_TradePoint(token)
    const {getActiveBranches} = DB_Branch(token)
    const [allData, setAllData] = useState([])
    const [selectedTradePoint, setSelectedTradePoint] = useState([])
    const [branches, setBranches] = useState([])
    const [selectedBranch, setSelectedBranch] = useState ('')
    const [showAllTradePoints, setShowAllTradePoints] = useState (false)
    const [load, setLoad] = useState(false)
    const filterOption = (inputValue, option) => {
        return (option.name.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
            || option.address.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
            || option.code.toUpperCase().indexOf(inputValue.toUpperCase()) > -1)
    }

    useEffect(() => {
        getActiveBranches()
            .then( res => {
                setBranches(res.data)
            })
    }, [])

    useEffect(() => {
        if (org_structure_id !== 'new' && selectedBranch !== undefined) {
            setLoad(true)
            tradePointResponsePerson(org_structure_id, selectedBranch, showAllTradePoints)
                .then( res => {
                    setAllData(res.data.all_trade_points)
                    setSelectedTradePoint(res.data.selected_trade_points)
                })
                .finally( () => {
                    setLoad(false)
                })
        }
    }, [selectedBranch, showAllTradePoints])

    useEffect(() => {
        if (!show) {
            setAllData([])
            setSelectedTradePoint([])
            setSelectedBranch('')
            setShowAllTradePoints(false)
        }
    }, [show])

    const clearBranch = () => {
        setAllData([])
        setSelectedTradePoint([])
        setSelectedBranch('')
    }

    const saveButton = () => {
        setLoad(true)
        saveTradePointResponsePerson(org_structure_id, selectedBranch, selectedTradePoint)
            .then(res => {
                if (res.status === 200) {
                    message.success(t('success'))
                    setShow(false)
                } else {
                    message.error(t('error'))
                }
            })
            .catch(e => {
                console.log(e)
                message.error(e.message)
            })
            .finally(() => {
                setLoad(false)
            })
    }

    return(
        <Drawer
            title={t('trade_points')}
            closable={false}
            // onClose={() => setShow(false)}
            visible={show}
            placement={'bottom'}
            size={'large'}
            extra={
                <Space>
                    <Button type={'primary'} shape={'round'} key={1} onClick={saveButton}>{t('save')}</Button>
                    <Button key={2} shape={'round'} onClick={() => setShow(false)}>{t('cancel')}</Button>
                </Space>
            }
        >
            <Select
                showSearch
                onChange={e => setSelectedBranch(e)}
                onClear={clearBranch}
                value={selectedBranch}
                optionFilterProp="name"
                optionLabelProp="name"
                allowClear
                style={{width:'50%'}}>
                {branches.map(u =>
                    <Select.Option key={u.id} value={u.id} name={t(u.name)}>{t(u.name)}</Select.Option>
                )}
            </Select>
            <Switch defaultChecked={showAllTradePoints} style={{margin:'0 10pt 0 20pt'}} onChange={e => setShowAllTradePoints(e)}/> {t('show_all_trade_points')}
            <WarningTwoTone style={{marginLeft:'5pt'}} twoToneColor="red"/>
            <Spin spinning={load}>
                <Transfer
                    dataSource={allData}
                    rowKey={item => (item.code)}
                    titles={[t('all'), t('selected')]}
                    showSearch
                    filterOption={filterOption}
                    targetKeys={selectedTradePoint}
                    onChange={e => setSelectedTradePoint(e)}
                    render={item =>
                            <>
                                {item.name}
                                <br/>
                                {item.address}
                            </>
                    }
                    style={{marginTop: '10pt'}}
                    // disabled={disableTradePoint}
                    listStyle={{background: '#fff'}}
                    // oneWay={true}
                    pagination
                />
            </Spin>
        </Drawer>
    )
}